// src/app/pages/definition/CashRegister/CashRegisterTable.tsx
import React from 'react'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { ICashRegisterModel } from './CashRegisterModel'


export type CashRegisterRow = Omit<ICashRegisterModel, 'id' | 'createdAt' | 'updatedAt'> & {
  id?: string
  createdAt?: Date
  updatedAt?: Date
}

type Props = {
  data: CashRegisterRow[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (row: CashRegisterRow) => void
  onDelete?: (row: CashRegisterRow) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const CashRegisterTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const columns: TableColumn<CashRegisterRow>[] = [
    { key: 'name', label: 'Ad', className: 'fw-semibold', sortable: true },
    { key: 'lastName', label: 'Soyad', sortable: true },
    { key: 'receiptNo', label: 'Makbuz No', sortable: true },
    { key: 'kasaKodu', label: 'Kasa Kodu', sortable: true },
    {
      key: 'kasaTutar',
      label: 'Kasa Tutar',
      sortable: true,
      render: (row) => `${row.kasaTutar ?? 0}`,
    },
    {
      key: 'createdAt',
      label: 'Oluşturulma',
      sortable: true,
      render: (row) => (row.createdAt ? row.createdAt.toLocaleString() : '-'),
    },
  ]

  const actions: TableAction<CashRegisterRow>[] = [
    { label: 'Düzenle', icon: 'bi bi-pencil', className: 'btn-light-primary me-2', onClick: (r) => onEdit?.(r) },
    { label: 'Sil', icon: 'bi bi-trash', className: 'btn-light-danger', onClick: (r) => onDelete?.(r) },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz Kasa kaydı bulunamadı'
    />
  )
}
